"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2208],{

/***/ 10411:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ submitLoginForm; }
/* harmony export */ });
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants_http__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23359);
/* harmony import */ var _constants_resources__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41238);
/* harmony import */ var _common_auth__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48106);
/* harmony import */ var _common_cookieOptions__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62049);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}





var submitLoginForm = function() {
    var _ref = _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(body, setUid) {
        var response, status, _data, Code, Data;
        return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,_constants_http__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_constants_resources__WEBPACK_IMPORTED_MODULE_2__/* ["default"].MEMBER */ .Z.MEMBER).post(body);
                case 2:
                    response = _ctx.sent;
                    status = response.status;
                    _data = response.data, Code = _data.Code, Data = _data.Data;
                    if (!(status === 200)) {
                        _ctx.next = 16;
                        break;
                    }
                    if (!(Code === "0000")) {
                        _ctx.next = 12;
                        break;
                    }
                    (0,_common_auth__WEBPACK_IMPORTED_MODULE_3__/* .setCookie */ .d8)("token", Data.token, _common_cookieOptions__WEBPACK_IMPORTED_MODULE_4__/* .authCookie */ .Z);
                    if (setUid === true) {
                        (0,_common_auth__WEBPACK_IMPORTED_MODULE_3__/* .setCookie */ .d8)("uid", body.uid, _common_cookieOptions__WEBPACK_IMPORTED_MODULE_4__/* .uidCookie */ .U);
                    } else {
                        (0,_common_auth__WEBPACK_IMPORTED_MODULE_3__/* .removeCookie */ .nJ)("uid");
                    }
                    return _ctx.abrupt("return", "Success");
                case 12:
                    if (!(Code === "9999")) {
                        _ctx.next = 14;
                        break;
                    }
                    return _ctx.abrupt("return", Data.Msg);
                case 14:
                    _ctx.next = 17;
                    break;
                case 16:
                    return _ctx.abrupt("return", console.log("\uC815\uC0C1\uC801\uC778 \uC694\uCCAD\uC774 \uC544\uB2D9\uB2C8\uB2E4. \uB098\uC911\uC5D0 \uB2E4\uC2DC \uC2DC\uB3C4\uD574\uC8FC\uC138\uC694."));
                case 17:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function submitLoginForm(body, setUid) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 55262:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ numberCheck; }
/* harmony export */ });
var numberCheck = function(value) {
    return /^[1-9]\d*$/.test(value);
};


/***/ }),

/***/ 62049:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ uidCookie; },
/* harmony export */   "Z": function() { return /* binding */ authCookie; }
/* harmony export */ });
/*
- attributes

expires: 만료 기간 (date)

maxAge: 클라이언트가 쿠키를 수신한 시점부터 쿠키의 상대적인 최대 수명 (sec)

secure: 웹 브라우저와 웹 서버가 https로 통신하는 경우에만 쿠키 저장

httpOnly: document.cookie라는 자바스크립트 코드로 쿠키에 비정상적으로 접속하는 것을 막는 옵션
*/ var authCookie = {
    sameSite: "strict",
    path: "/"
};
var uidCookie = {
    sameSite: "strict",
    path: "/",
    maxAge: 2592000
};


/***/ }),

/***/ 86782:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _common_NumberCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(55262);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  color: #7e7e7e;\n  font-size: 14px;\n  font-weight: 400;\n  padding: 0 10px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  color: #7e7e7e;\n  font-size: 14px;\n  font-weight: 400;\n  padding: 0 10px;\n  &::before {\n    content: none !important;\n    display: none !important;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



 // numberCheck 함수 import

var StyledLink = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].a.withConfig */ .ZP.a.withConfig({
    componentId: "sc-5cacada6-0"
})(_templateObject());
var StyledTitle = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-5cacada6-1"
})(_templateObject1());
var Breadcrumb2 = function(param) {
    var categoryName = param.categoryName, categoryHash = param.categoryHash, hash = param.hash, ename = param.ename;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    // 해시가 숫자인지 확인 (페이지 번호인 경우)
    var isNumericHash = hash && (0,_common_NumberCheck__WEBPACK_IMPORTED_MODULE_4__/* .numberCheck */ .M)(hash);
    var isNumericRouterHash = router.query.hash && (0,_common_NumberCheck__WEBPACK_IMPORTED_MODULE_4__/* .numberCheck */ .M)(router.query.hash);
    // 표시할 해시 결정 (숫자인 경우 표시하지 않음)
    var displayHash = isNumericHash ? null : hash;
    var displayRouterHash = isNumericRouterHash ? null : router.query.hash;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: categoryHash && categoryName && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "page-header mb-30",
            style: {
                wordBreak: "keep-all"
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "row",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                            className: "mb-15 text-capitalize",
                            children: categoryName
                        }),
                        !router.query.search && !router.query.garo && !router.query.sero && !router.query.high && !router.query.erange && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "breadcrumb",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledLink, {
                                    href: "/",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                        rel: "nofollow",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                className: "fi-rs-home mr-5"
                                            }),
                                            "\uD648"
                                        ]
                                    })
                                }),
                                ">",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledLink, {
                                    href: "/products/",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                        children: "\uC0C1\uD488\uAD6C\uB9E4"
                                    })
                                }),
                                hash ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                    children: [
                                        ">",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledLink, {
                                            href: "/products/".concat(ename, "/"),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                children: categoryName
                                            })
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                    children: [
                                        ">",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledTitle, {
                                            children: categoryName
                                        })
                                    ]
                                }),
                                (displayHash || displayRouterHash) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                    children: [
                                        ">",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledTitle, {
                                            children: displayHash || displayRouterHash
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Breadcrumb2);


/***/ }),

/***/ 18646:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ list_ProductsList; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/products/list/Proucts-list-styles.js
var Proucts_list_styles = __webpack_require__(30938);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 22 modules
var es = __webpack_require__(64384);
// EXTERNAL MODULE: ./components/layout/Breadcrumb2.js
var Breadcrumb2 = __webpack_require__(86782);
// EXTERNAL MODULE: ./api/constants/http.js
var http = __webpack_require__(23359);
;// CONCATENATED MODULE: ./common/util/filterProduct.js
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
// Filter Products By Filters
/* harmony default export */ function filterProduct(productList, filters, body) {
    var filteredList = _toConsumableArray(productList);
    for(var key in filters){
        if (filters.code !== body.code || filters.hash !== body.hash) {
            return filteredList;
        }
        if (key === "sizes") {
            var sizeCheckList = filteredList;
            if (Number(filters.sizes.horizontal) > 0) {
                sizeCheckList = sizeCheckList.filter(function(el) {
                    return Number(filters.sizes.horizontal) - Number(filters.sizes.range || 0) <= Number(el.horizontal) && Number(el.horizontal) <= Number(filters.sizes.horizontal) + Number(filters.sizes.range || 0);
                });
            }
            if (Number(filters.sizes.vertical) > 0) {
                sizeCheckList = sizeCheckList.filter(function(el) {
                    return Number(filters.sizes.vertical) - Number(filters.sizes.range || 0) <= Number(el.vertical) && Number(el.vertical) <= Number(filters.sizes.vertical) + Number(filters.sizes.range || 0);
                });
            }
            if (Number(filters.sizes.height) > 0) {
                sizeCheckList = sizeCheckList.filter(function(el) {
                    return Number(filters.sizes.height) - Number(filters.sizes.range || 0) <= Number(el.height) && Number(el.height) <= Number(filters.sizes.height) + Number(filters.sizes.range || 0);
                });
            }
            return sizeCheckList;
        }
    }
    return filteredList;
};

// EXTERNAL MODULE: ./redux/constants/actionTypes.js
var actionTypes = __webpack_require__(46330);
;// CONCATENATED MODULE: ./redux/action/product.js
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}





// Fetch Product fetchProduct
var fetchProduct = function(url, filters, body) {
    return function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(dispatch) {
            var ref, ref1, res, resData, filteredList;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        ;
                        _ctx.next = 4;
                        return (0,http/* default */.Z)(url).post(body);
                    case 4:
                        res = _ctx.sent;
                        resData = {
                            code: (ref = res.data) === null || ref === void 0 ? void 0 : ref.Code,
                            data: (ref1 = res.data.Data) === null || ref1 === void 0 ? void 0 : ref1.Rows
                        };
                        filteredList = filterProduct(resData.data, filters, body);
                        dispatch({
                            type: actionTypes/* FETCHED_PRODUCT */.jP,
                            payload: {
                                products: filteredList
                            }
                        });
                        return _ctx.abrupt("return", "complete");
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", _ctx.t0);
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    11
                ]
            ]);
        }));
        return function(dispatch) {
            return _ref.apply(this, arguments);
        };
    }();
};

// EXTERNAL MODULE: ./redux/action/productFiltersAction.js
var productFiltersAction = __webpack_require__(7330);
// EXTERNAL MODULE: ./components/ecommerce/singleProduct/SingleProduct.js
var SingleProduct = __webpack_require__(57416);
// EXTERNAL MODULE: ./redux/action/loading.js
var loading = __webpack_require__(19828);
// EXTERNAL MODULE: ./common/NumberCheck.js
var NumberCheck = __webpack_require__(55262);
;// CONCATENATED MODULE: ./components/ecommerce/Filter/Tags.js







 // numberCheck 함수 import
var Tags = function(param) {
    var _$updateProductFilters = param.updateProductFilters, productFilters = param.productFilters, categoryHash = param.categoryHash, categoryName = param.categoryName, dummyList = param.dummyList, _$isLoading = param.isLoading, _$isLoaded = param.isLoaded;
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(""), selectedTags = ref[0], setSelectedTags = ref[1];
    var ref1 = (0,react.useState)(""), categorySlug = ref1[0], setCategorySlug = ref1[1];
    // 코드에서 slug를 찾는 함수
    var findCategorySlug = function(code) {
        if (!dummyList || !dummyList.category) return "";
        var category = dummyList.category.find(function(cat) {
            return cat.code === code;
        });
        return category ? category.ename : "";
    };
    // 현재 slug 경로를 찾는 함수
    var getCurrentSlug = function() {
        if (router.query.slug) return router.query.slug;
        if (router.query.code) return findCategorySlug(router.query.code);
        return "";
    };
    // 현재 해시태그 가져오기 - URL 경로 분석
    var getCurrentHash = function() {
        try {
            // URL 디코딩하여 경로 구조 분석
            var decodedPath = decodeURIComponent(router.asPath);
            var pathParts = decodedPath.split("/").filter(function(part) {
                return part;
            });
            // /products/[slug]/[hash]/ 형태인 경우
            if (pathParts.length >= 3 && pathParts[0] === "products") {
                var hash = pathParts[2];
                // 쿼리 파라미터나 다른 특수문자 제거
                var cleanHash = hash.split("?")[0].split("#")[0];
                // 숫자형 해시는 페이지 번호로 처리 (전체보기로 간주)
                if ((0,NumberCheck/* numberCheck */.M)(cleanHash)) {
                    return "";
                }
                return cleanHash;
            } else if (router.query.hash) {
                // 숫자형 해시는 페이지 번호로 처리 (전체보기로 간주)
                if ((0,NumberCheck/* numberCheck */.M)(router.query.hash)) {
                    return "";
                }
                return router.query.hash;
            }
        } catch (error) {
            console.error("URL \uD30C\uC2F1 \uC911 \uC624\uB958 \uBC1C\uC0DD:", error);
            // 쿼리 파라미터 사용 시도
            if (router.query.hash) {
                // 숫자형 해시는 페이지 번호로 처리 (전체보기로 간주)
                if ((0,NumberCheck/* numberCheck */.M)(router.query.hash)) {
                    return "";
                }
                return router.query.hash;
            }
        }
        return "";
    };
    var handleClick = function(target) {
        setSelectedTags(target);
        var slug = getCurrentSlug();
        if (!slug) return;
        // 전체보기인 경우 해시태그 경로 생략
        if (target === "") {
            router.push("/products/".concat(slug));
        } else {
            router.push("/products/".concat(slug, "/").concat(target));
        }
    };
    (0,react.useEffect)(function() {
        if (!router.isReady) return;
        // 현재 slug 설정
        setCategorySlug(getCurrentSlug());
        // 현재 활성화된 해시태그 결정
        var currentHash = getCurrentHash();
        if (selectedTags !== currentHash) {
            setSelectedTags(currentHash || "");
            if (categoryHash) {
                _$updateProductFilters({
                    hash: currentHash || ""
                });
            }
        }
    }, [
        router.isReady,
        router.query,
        router.asPath,
        categoryHash,
        dummyList
    ]);
    (0,react.useEffect)(function() {
        if (selectedTags) {
            _$updateProductFilters({
                hash: selectedTags
            });
        }
    }, [
        selectedTags
    ]);
    // 현재 해시태그 - 렌더링 시마다 계산
    var currentHash1 = getCurrentHash();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Proucts_list_styles/* MenuList */.qy, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    className: "hover-up",
                    onClick: function() {
                        return handleClick("");
                    },
                    style: {
                        cursor: "pointer"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        className: currentHash1 === "" ? "cat-item text-brand" : "cat-item",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                className: "fi-rs-caret-right mr-5"
                            }),
                            " ",
                            "\uC804\uCCB4\uBCF4\uAE30"
                        ]
                    })
                }),
                (categoryHash === null || categoryHash === void 0 ? void 0 : categoryHash.length) > 0 && categoryHash.map(function(tag, i) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: "hover-up",
                        onClick: function() {
                            return handleClick(tag);
                        },
                        style: {
                            cursor: "pointer"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            className: currentHash1 === tag ? "cat-item text-brand" : "cat-item",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                    className: "fi-rs-caret-right mr-5"
                                }),
                                " ",
                                tag
                            ]
                        })
                    }, i);
                })
            ]
        })
    });
};
var mapStateToProps = function(state) {
    return {
        productFilters: state.productFilters,
        dummyList: state.dummyList
    };
};
var mapDidpatchToProps = {
    updateProductFilters: productFiltersAction/* updateProductFilters */.lG,
    isLoading: loading/* isLoading */.h,
    isLoaded: loading/* isLoaded */.k
};
/* harmony default export */ var Filter_Tags = ((0,es/* connect */.$j)(mapStateToProps, mapDidpatchToProps)(Tags));

// EXTERNAL MODULE: ./components/sliders/Category.js
var Category = __webpack_require__(64728);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/layout/Layout.js + 38 modules
var Layout = __webpack_require__(32511);
// EXTERNAL MODULE: ./components/products/list/TableTypeList.js
var TableTypeList = __webpack_require__(17461);
// EXTERNAL MODULE: ./common/auth.js + 4 modules
var auth = __webpack_require__(48106);
// EXTERNAL MODULE: ./components/elements/requestLoginModal.js
var requestLoginModal = __webpack_require__(56177);
// EXTERNAL MODULE: ./common/modalOverflowHook.js
var modalOverflowHook = __webpack_require__(39277);
// EXTERNAL MODULE: ./components/csboard/notice/notice-pagination.js
var notice_pagination = __webpack_require__(63820);
// EXTERNAL MODULE: ./hook/products/usePaginationHandler.js
var usePaginationHandler = __webpack_require__(43494);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./common/alert.js
var common_alert = __webpack_require__(55150);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/modern/QueryClientProvider.js
var QueryClientProvider = __webpack_require__(30202);
;// CONCATENATED MODULE: ./components/products/list/ProductSizeFilter.js
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n\n  > span {\n    margin-right: 10px;\n  }\n  .btn {\n    height: 30px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size: 14px;\n    padding: 0 20px;\n    border-radius: 10px;\n  }\n\n  @media (max-width: 991px) {\n    justify-content: flex-start;\n  }\n  @media (max-width: 767px) {\n    display: none;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: none;\n  flex-direction: column;\n\n  & span {\n    margin-right: 10px;\n    text-align: end;\n    font-size: 14px;\n  }\n\n  grid-template-columns: repeat(3, 1fr);\n  grid-column-gap: 10px;\n  grid-row-gap: 10px;\n  & button {\n    border: none;\n    background: #3bb77e;\n    color: #fff;\n    border-radius: 10px;\n    font-size: 14px;\n    word-break: keep-all;\n    height: 30px;\n    :hover {\n      background-color: #fd7e14;\n    }\n  }\n\n  @media (max-width: 767px) {\n    display: grid;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  max-width: 120px;\n  height: 30px;\n  text-align: center;\n  padding: 0 10px;\n  margin-right: 10px;\n  @media (max-width: 767px) {\n    font-size: 14px;\n    width: 100%;\n    max-width: none;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  width: fit-content;\n  height: 30px;\n  text-align: center;\n  border: 1px solid #ececec;\n  background-color: #fff;\n  border-radius: 10px;\n  margin-right: 10px;\n  padding: 0px 20px;\n\n  @media (max-width: 767px) {\n    font-size: 14px;\n    width: 100%;\n    max-width: none;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  margin-right: 15px;\n  font-size: 14px;\n  color: #666;\n\n  @media (max-width: 767px) {\n    margin-bottom: 10px;\n    font-size: 13px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}








var SizeFilterWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f8286985-0"
})(_templateObject());
var MobileSizeFilterWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f8286985-1"
})(_templateObject1());
var SizeInput = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
    componentId: "sc-f8286985-2"
})(_templateObject2());
var SizeSelect = styled_components_browser_esm/* default.select.withConfig */.ZP.select.withConfig({
    componentId: "sc-f8286985-3"
})(_templateObject3());
// 사이즈 형식을 표시하는 레이블 컴포넌트 추가
var SizeFormatLabel = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f8286985-4"
})(_templateObject4());
var ProductSizeFilter = function(param) {
    var _$updateProductFilters = param.updateProductFilters, products = param.products, productFilters = param.productFilters, handleSizeFilter = param.handleSizeFilter, viewHeight = param.viewHeight, categorySizeSearch = param.categorySizeSearch, selectedCategory = param.selectedCategory, setFilteredProducts = param.setFilteredProducts, allProducts = param.allProducts, setAllProducts = param.setAllProducts, updateUnitParams = param.updateUnitParams, searchParams = param.searchParams, setSearchParams = param.setSearchParams, setPage = param.setPage, currentCategory = param.currentCategory, resetPagination = param.resetPagination;
    var ref8, ref1, ref2, ref3;
    var router = (0,next_router.useRouter)();
    var queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
    var ref4 = (0,react.useState)({
        horizontal: (searchParams === null || searchParams === void 0 ? void 0 : (ref8 = searchParams.unit) === null || ref8 === void 0 ? void 0 : ref8.garo) !== "0" ? searchParams.unit.garo : "",
        vertical: (searchParams === null || searchParams === void 0 ? void 0 : (ref1 = searchParams.unit) === null || ref1 === void 0 ? void 0 : ref1.sero) !== "0" ? searchParams.unit.sero : "",
        height: (searchParams === null || searchParams === void 0 ? void 0 : (ref2 = searchParams.unit) === null || ref2 === void 0 ? void 0 : ref2.high) !== "0" ? searchParams.unit.high : "",
        range: (searchParams === null || searchParams === void 0 ? void 0 : (ref3 = searchParams.unit) === null || ref3 === void 0 ? void 0 : ref3.erange) !== "0" ? searchParams.unit.erange : ""
    }), selectedSizes = ref4[0], setSelectedSizes = ref4[1];
    // 페이지 진입 시 초기 값 설정
    (0,react.useEffect)(function() {
        _$updateProductFilters(_objectSpread({}, productFilters, {
            sizes: {
                horizontal: "",
                vertical: "",
                height: "",
                range: ""
            }
        }));
        setSelectedSizes({
            horizontal: "",
            vertical: "",
            height: "",
            range: ""
        });
    }, []);
    (0,react.useEffect)(function() {
        var ref, ref5, ref6, ref7;
        setSelectedSizes({
            horizontal: (searchParams === null || searchParams === void 0 ? void 0 : (ref = searchParams.unit) === null || ref === void 0 ? void 0 : ref.garo) !== "0" ? searchParams.unit.garo : "",
            vertical: (searchParams === null || searchParams === void 0 ? void 0 : (ref5 = searchParams.unit) === null || ref5 === void 0 ? void 0 : ref5.sero) !== "0" ? searchParams.unit.sero : "",
            height: (searchParams === null || searchParams === void 0 ? void 0 : (ref6 = searchParams.unit) === null || ref6 === void 0 ? void 0 : ref6.high) !== "0" ? searchParams.unit.high : "",
            range: (searchParams === null || searchParams === void 0 ? void 0 : (ref7 = searchParams.unit) === null || ref7 === void 0 ? void 0 : ref7.erange) !== "0" ? searchParams.unit.erange : ""
        });
    }, [
        searchParams
    ]);
    (0,react.useEffect)(function() {
        if (products === null || products === void 0 ? void 0 : products.items) {
            setAllProducts(products.items);
            setFilteredProducts(products.items);
        }
    }, [
        products
    ]);
    // ProductSizeFilter.js에서 handleFilter 함수 수정
    var handleFilter = function() {
        // 1. 검색 파라미터 업데이트 (페이지는 1로 초기화)
        setSearchParams(function(prev) {
            return _objectSpread({}, prev, {
                unit: {
                    garo: selectedSizes.horizontal || "0",
                    sero: selectedSizes.vertical || "0",
                    high: selectedSizes.height || "0",
                    erange: selectedSizes.range || "0"
                },
                page: 1
            });
        });
        // 2. 페이지 상태 직접 업데이트 (컴포넌트로 props 전달 필요)
        setPage(1);
        // 4. 데이터 무효화하여 새로 요청 트리거
        queryClient.invalidateQueries([
            "categoryProducts",
            currentCategory.code,
            currentCategory.hash,
            1, 
        ]);
        // 5. 필터링 로직 실행
        var filtered = allProducts.filter(function(product) {
        // 기존 필터링 코드...
        });
        setFilteredProducts(filtered);
        // 6. usePaginationHandlerModified의 currentPage 초기화
        if (resetPagination) {
            resetPagination(1);
        }
    };
    var onChangeSize = function(id) {
        return function(e) {
            setSelectedSizes(_objectSpread({}, selectedSizes, _defineProperty({}, id, e.target.value)));
        };
    };
    var handleInput = function(e) {
        if (e.key === "Enter") {
            e.preventDefault();
            setTimeout(function() {
                handleFilter();
            }, 200);
        }
    };
    var sizes = [
        0,
        10,
        20,
        30,
        40,
        50,
        60
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SizeFilterWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SizeInput, {
                        onChange: onChangeSize("horizontal"),
                        placeholder: "\uAC00\uB85Cmm",
                        value: selectedSizes.horizontal,
                        onKeyDown: handleInput
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SizeInput, {
                        onChange: onChangeSize("vertical"),
                        placeholder: "\uC138\uB85Cmm",
                        value: selectedSizes.vertical,
                        onKeyDown: handleInput
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SizeInput, {
                        onChange: onChangeSize("height"),
                        placeholder: "\uB192\uC774mm",
                        value: selectedSizes.height,
                        onKeyDown: handleInput
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SizeSelect, {
                        id: "sizeFilter",
                        name: "sizeFilter",
                        onChange: onChangeSize("range"),
                        value: selectedSizes.range,
                        children: sizes.map(function(el, i) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("option", {
                                value: el > 0 ? el : "",
                                children: [
                                    "\xb1 ",
                                    el
                                ]
                            }, i);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: "btn",
                        onClick: handleFilter,
                        children: "\uC0AC\uC774\uC988 \uAC80\uC0C9"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(MobileSizeFilterWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SizeInput, {
                        onChange: onChangeSize("horizontal"),
                        placeholder: "\uAC00\uB85C",
                        value: selectedSizes.horizontal
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SizeInput, {
                        onChange: onChangeSize("vertical"),
                        placeholder: "\uC138\uB85C",
                        value: selectedSizes.vertical
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SizeInput, {
                        onChange: onChangeSize("height"),
                        placeholder: "\uB192\uC774",
                        value: selectedSizes.height
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SizeSelect, {
                        id: "sizeFilter",
                        name: "sizeFilter",
                        onChange: onChangeSize("range"),
                        value: selectedSizes.range,
                        children: sizes.map(function(el, i) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("option", {
                                value: el > 0 ? el : "",
                                children: [
                                    "\xb1 ",
                                    el
                                ]
                            }, i);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        onClick: handleFilter,
                        children: "\uC0AC\uC774\uC988 \uAC80\uC0C9"
                    })
                ]
            })
        ]
    });
};
var ProductSizeFilter_mapStateToProps = function(state) {
    return {
        products: state.products,
        productFilters: state.productFilters
    };
};
var ProductSizeFilter_mapDidpatchToProps = {
    updateProductFilters: productFiltersAction/* updateProductFilters */.lG
};
/* harmony default export */ var list_ProductSizeFilter = ((0,es/* connect */.$j)(ProductSizeFilter_mapStateToProps, ProductSizeFilter_mapDidpatchToProps)(ProductSizeFilter));

// EXTERNAL MODULE: ./api/products.js
var api_products = __webpack_require__(81628);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/modern/useQuery.js + 7 modules
var useQuery = __webpack_require__(87633);
;// CONCATENATED MODULE: ./hook/products/useSearchAllListQuery.js
function useSearchAllListQuery_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function useSearchAllListQuery_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function useSearchAllListQuery_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                useSearchAllListQuery_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                useSearchAllListQuery_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || useSearchAllListQuery_unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function useSearchAllListQuery_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return useSearchAllListQuery_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return useSearchAllListQuery_arrayLikeToArray(o, minLen);
}





var useSearchAllListQuery = function(param1) {
    var _initialPage = param1.initialPage, initialPage = _initialPage === void 0 ? 1 : _initialPage, isNumericSlug = param1.isNumericSlug, queryPage = param1.queryPage;
    var prevPageRef = (0,react.useRef)(initialPage);
    var page = queryPage || initialPage;
    var ref = (0,react.useState)(0), totalPages = ref[0], setTotalPages = ref[1];
    var fetchAllProducts = function() {
        var _ref = useSearchAllListQuery_asyncToGenerator(runtime_default().mark(function _callee(param) {
            var queryKey, _queryKey, _, queryPageNumber, body, res;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        queryKey = param.queryKey;
                        _queryKey = _slicedToArray(queryKey, 2), _ = _queryKey[0], queryPageNumber = _queryKey[1];
                        // 현재 페이지를 저장
                        prevPageRef.current = queryPageNumber;
                        (0,loading/* isLoading */.h)();
                        _ctx.prev = 4;
                        body = {
                            modes: "AllListSet",
                            page: queryPageNumber,
                            page_rows: 20
                        };
                        _ctx.next = 8;
                        return (0,api_products/* ProductsApi */.qO)(body);
                    case 8:
                        res = _ctx.sent;
                        if (!((res === null || res === void 0 ? void 0 : res.Code) === "0000")) {
                            _ctx.next = 13;
                            break;
                        }
                        return _ctx.abrupt("return", res.Data.Data);
                    case 13:
                        return _ctx.abrupt("return", {
                            data: [],
                            total_count: 0,
                            total_page: 0
                        });
                    case 14:
                        _ctx.next = 20;
                        break;
                    case 16:
                        _ctx.prev = 16;
                        _ctx.t0 = _ctx["catch"](4);
                        console.error(_ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : _ctx.t0.message);
                        return _ctx.abrupt("return", {
                            data: [],
                            total_count: 0,
                            total_page: 0
                        });
                    case 20:
                        _ctx.prev = 20;
                        (0,loading/* isLoaded */.k)();
                        return _ctx.finish(20);
                    case 23:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    4,
                    16,
                    20,
                    23
                ]
            ]);
        }));
        return function fetchAllProducts(_) {
            return _ref.apply(this, arguments);
        };
    }();
    var ref1 = (0,useQuery/* useQuery */.a)({
        queryKey: [
            "products",
            page
        ],
        queryFn: fetchAllProducts,
        enabled: isNumericSlug,
        keepPreviousData: false,
        staleTime: 0,
        // 쿼리가 중복으로 실행되는 것을 방지
        refetchOnMount: false,
        refetchOnWindowFocus: false
    }), productsData = ref1.data, queryLoading = ref1.isLoading;
    // 총 페이지 수 계산
    (0,react.useEffect)(function() {
        if (productsData) {
            var calculatedTotalPages = productsData.total_page || (productsData.total_count ? Math.ceil(productsData.total_count / 20) : 0);
            setTotalPages(calculatedTotalPages);
        }
    }, [
        productsData
    ]);
    return {
        productsData: productsData,
        queryLoading: queryLoading,
        currentPage: page
    };
};

;// CONCATENATED MODULE: ./hook/products/useCategoryListQuery.js
function useCategoryListQuery_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function useCategoryListQuery_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                useCategoryListQuery_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                useCategoryListQuery_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



var useCategoryListQuery = function() {
    var queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
    var division =  true ? localStorage.getItem("categoryType") || "S" : 0;
    var queryKey = [
        "categoryList",
        division
    ];
    var cached = queryClient.getQueryData(queryKey);
    return (0,useQuery/* useQuery */.a)({
        queryKey: queryKey,
        queryFn: useCategoryListQuery_asyncToGenerator(runtime_default().mark(function _callee() {
            var body, res;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!cached) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return", cached);
                    case 2:
                        body = {
                            modes: "ListSet",
                            division: division
                        };
                        _ctx.next = 5;
                        return (0,api_products/* listSetCategory */.Hc)(body);
                    case 5:
                        res = _ctx.sent;
                        if (!((res === null || res === void 0 ? void 0 : res.code) === "0000")) {
                            _ctx.next = 10;
                            break;
                        }
                        return _ctx.abrupt("return", res.data || []);
                    case 10:
                        throw new Error((res === null || res === void 0 ? void 0 : res.Msg) || "\uCE74\uD14C\uACE0\uB9AC \uB370\uC774\uD130\uB97C \uBD88\uB7EC\uC62C \uC218 \uC5C6\uC2B5\uB2C8\uB2E4.");
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        })),
        enabled: "object" !== "undefined",
        staleTime: Infinity,
        cacheTime: Infinity
    });
};

;// CONCATENATED MODULE: ./components/ecommerce/Filter/Checkbox.js

var CheckBox = function(param) {
    var filters = param.filters, handleCheckBox = param.handleCheckBox;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: filters.map(function(item, id) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        type: "checkbox",
                        className: "form-check-input",
                        name: item.name,
                        value: item.value,
                        checked: item.checked,
                        onChange: function(e) {
                            return handleCheckBox(e);
                        },
                        id: item.value,
                        style: {
                            padding: "10px"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                        className: "form-check-label ml-5",
                        htmlFor: item.value,
                        style: {
                            textTransform: "capitalize"
                        },
                        children: [
                            " ",
                            item.label
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                ]
            }, id);
        })
    });
};
/* harmony default export */ var Checkbox = (CheckBox);

// EXTERNAL MODULE: ./store/useBannerStore.js
var useBannerStore = __webpack_require__(13880);
;// CONCATENATED MODULE: ./components/products/list/ProductsList.js
function ProductsList_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function ProductsList_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return ProductsList_arrayLikeToArray(arr);
}
function ProductsList_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function ProductsList_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                ProductsList_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                ProductsList_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function ProductsList_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ProductsList_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function ProductsList_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ProductsList_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ProductsList_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ProductsList_toConsumableArray(arr) {
    return ProductsList_arrayWithoutHoles(arr) || ProductsList_iterableToArray(arr) || ProductsList_unsupportedIterableToArray(arr) || ProductsList_nonIterableSpread();
}
function ProductsList_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return ProductsList_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ProductsList_arrayLikeToArray(o, minLen);
}





























var ProductsList = function(param) {
    var products = param.products, siteConfig = param.siteConfig, productFilters = param.productFilters, _$fetchProduct = param.fetchProduct, _$updateProductFilters = param.updateProductFilters, _$updateProductCategory = param.updateProductCategory, _$isLoading = param.isLoading, _$isLoaded = param.isLoaded, banners = param.banners, dummyList = param.dummyList, loading = param.loading, userDevice = param.userDevice, disableRouting = param.disableRouting, fixedCategory = param.fixedCategory, seoData = param.seoData, _initialPage = param.initialPage, initialPage = _initialPage === void 0 ? 1 : _initialPage;
    var ref25, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var prodLeftBtm = (0,useBannerStore/* useBannerStore */.Q)(function(s) {
        return s;
    }).prodLeftBtm;
    var router = (0,next_router.useRouter)();
    var queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
    var getEnameFromPath = function() {
        if (!router.isReady) return "";
        var slug = router.query.slug;
        return slug || "";
    };
    var ename = getEnameFromPath();
    // 리스트 타입
    var ref8 = (0,react.useState)(""), viewType = ref8[0], setViewType = ref8[1];
    // 상품 리스트
    var ref9 = (0,react.useState)([]), productList = ref9[0], setProductList = ref9[1];
    var ref10 = (0,react.useState)((products === null || products === void 0 ? void 0 : products.items) || []), allProducts = ref10[0], setAllProducts = ref10[1]; //전체 상품 데이터
    var ref11 = (0,react.useState)((products === null || products === void 0 ? void 0 : products.items) || []), filteredProducts = ref11[0], setFilteredProducts = ref11[1]; //필터링된 데이터
    // 여기에 isSearching 함수 추가
    var isSearching = function() {
        // 기본 검색 파라미터와 다른 경우 검색 중으로 간주
        return searchParams.unit.garo !== "0" || searchParams.unit.sero !== "0" || searchParams.unit.high !== "0" || searchParams.unit.erange !== "0" || searchParams.brands.length > 0;
    };
    //상품 검색
    var ref12 = (0,react.useState)({
        unit: {
            garo: "0",
            sero: "0",
            high: "0",
            erange: "0"
        },
        page: initialPage,
        page_rows: 20,
        brands: []
    }), searchParams = ref12[0], setSearchParams = ref12[1];
    // 현재 카테고리와 해시태그를 저장하기 위한 상태
    var ref13 = (0,react.useState)({
        code: null,
        hash: ""
    }), currentCategory = ref13[0], setCurrentCategory = ref13[1];
    // breadCrumbs
    var ref14 = (0,react.useState)(""), categoryName = ref14[0], setCategoryName = ref14[1];
    var ref15 = (0,react.useState)(""), categorySizeSearch = ref15[0], setCategorySizeSearch = ref15[1];
    var ref16 = (0,react.useState)([]), categoryHash = ref16[0], setCategoryHash = ref16[1];
    // 로그인 모달
    var ref17 = (0,react.useState)(false), openLoginModal = ref17[0], setOpenLoginModal = ref17[1];
    //페이지네이션
    var ref18 = (0,react.useState)(initialPage), page = ref18[0], setPage = ref18[1];
    // URL에서 슬러그가 숫자인지 확인
    var isNumericSlug = router.isReady && router.query.slug && (0,NumberCheck/* numberCheck */.M)(router.query.slug);
    // 카테고리 상품 가져오기 Query
    var ref19 = (0,useQuery/* useQuery */.a)({
        queryKey: [
            "categoryProducts",
            currentCategory.code,
            currentCategory.hash,
            searchParams.page,
            searchParams.page_rows,
            searchParams.unit.garo,
            searchParams.unit.sero,
            searchParams.unit.high,
            searchParams.unit.erange,
            searchParams.brands, 
        ],
        queryFn: ProductsList_asyncToGenerator(runtime_default().mark(function _callee() {
            var body, res, ref, ref23, ref24, items, totalCount, totalPage;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!(!currentCategory.code || isNumericSlug)) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            items: [],
                            total_count: 0,
                            total_page: 0
                        });
                    case 2:
                        _$isLoading(); // 로딩 상태 시작
                        _ctx.prev = 3;
                        body = {
                            modes: "NewHashSet",
                            code: currentCategory.code,
                            hash: currentCategory.hash || "",
                            unit: JSON.stringify(searchParams.unit),
                            page: searchParams.page,
                            page_rows: searchParams.page_rows,
                            brands: JSON.stringify(searchParams.brands)
                        };
                        _ctx.next = 7;
                        return (0,api_products/* ProductsApi */.qO)(body);
                    case 7:
                        res = _ctx.sent;
                        if (!((res === null || res === void 0 ? void 0 : res.Code) === "0000")) {
                            _ctx.next = 17;
                            break;
                        }
                        ;
                        items = ((ref = res.Data.Rows) === null || ref === void 0 ? void 0 : ref.data) || [];
                        totalCount = ((ref23 = res.Data.Rows) === null || ref23 === void 0 ? void 0 : ref23.total_count) || 0;
                        totalPage = ((ref24 = res.Data.Rows) === null || ref24 === void 0 ? void 0 : ref24.total_page) || 0;
                        _$isLoaded(); // 로딩 완료
                        return _ctx.abrupt("return", {
                            items: items,
                            total_count: totalCount,
                            total_page: totalPage
                        });
                    case 17:
                        _$isLoaded(); // 로딩 완료
                        console.error("API \uC751\uB2F5 \uC624\uB958:", res === null || res === void 0 ? void 0 : res.data);
                        return _ctx.abrupt("return", {
                            items: [],
                            total_count: 0,
                            total_page: 0
                        });
                    case 20:
                        _ctx.next = 27;
                        break;
                    case 22:
                        _ctx.prev = 22;
                        _ctx.t0 = _ctx["catch"](3);
                        console.error("\uCE74\uD14C\uACE0\uB9AC \uC0C1\uD488 \uB85C\uB4DC \uC2E4\uD328:", _ctx.t0);
                        _$isLoaded(); // 로딩 완료
                        return _ctx.abrupt("return", {
                            items: [],
                            total_count: 0,
                            total_page: 0
                        });
                    case 27:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    3,
                    22
                ]
            ]);
        })),
        enabled: !!currentCategory.code && !isNumericSlug,
        onSuccess: function(data) {
            // 데이터 로드 후 처리
            setAllProducts(data.items || []);
            setFilteredProducts(data.items || []);
            // Redux 상태 업데이트
            _$fetchProduct(data.items || []);
            // 페이지네이션 업데이트 - 현재 URL의 페이지 번호 유지
            createPagination();
            // 검색 후 결과가 나오면 페이지 번호 유지
            var path = router.asPath.split("?")[0];
            var pathSegments = path.split("/").filter(function(segment) {
                return segment !== "";
            });
            // 마지막 세그먼트가 숫자인지 확인 (페이지 번호)
            var lastSegment = pathSegments[pathSegments.length - 1];
            if (!isNaN(parseInt(lastSegment, 10))) {
                var pageFromUrl = parseInt(lastSegment, 10);
                if (pageFromUrl > 0 && pageFromUrl <= data.total_page) {
                    // URL의 페이지 번호가 유효하면 해당 페이지로 설정
                    setPage(pageFromUrl);
                    setSearchParams(function(prev) {
                        return ProductsList_objectSpread({}, prev, {
                            page: pageFromUrl
                        });
                    });
                }
            }
        },
        // 검색 조건이 변경되어도 현재 페이지의 쿼리 캐시를 무효화하지 않도록 설정
        // 이렇게 하면 검색 중 페이지 간 이동 시 검색 상태가 유지됨
        keepPreviousData: true
    }), categoryProductsData = ref19.data, categoryLoading = ref19.isLoading;
    // 상품 데이터를 가져오는 함수
    var ref20 = useSearchAllListQuery({
        initialPage: initialPage,
        isNumericSlug: isNumericSlug,
        queryPage: page
    }), productsData = ref20.productsData, queryLoading = ref20.queryLoading;
    var regularPaginationProps = (0,usePaginationHandler/* usePaginationHandlerModified */.D)({
        products: {
            data: (categoryProductsData === null || categoryProductsData === void 0 ? void 0 : categoryProductsData.items) || [],
            total_count: (categoryProductsData === null || categoryProductsData === void 0 ? void 0 : categoryProductsData.total_count) || 0,
            total_page: (categoryProductsData === null || categoryProductsData === void 0 ? void 0 : categoryProductsData.total_page) || 0
        },
        initialPage: page
    });
    // productsData를 사용하는 부분은 이후에 정의
    var modifiedPaginationProps = (0,usePaginationHandler/* usePaginationHandlerModified */.D)({
        products: productsData || {
            data: [],
            total_count: 0,
            total_page: 0
        },
        initialPage: page
    });
    // 조건에 따라 적절한 핸들러 선택
    var ref21 = isNumericSlug ? modifiedPaginationProps : regularPaginationProps, handleActive = ref21.handleActive, getPaginationGroup = ref21.getPaginationGroup, createPagination = ref21.createPagination, currentPage = ref21.currentPage, pagination = ref21.pagination, pages = ref21.pages, limit = ref21.limit, resetPage = ref21.resetPage;
    // =========== URL 관련 함수 ===============
    // URL 업데이트 함수 - 검색 상태를 유지하면서 페이지만 변경 (쿼리스트링 사용 안함)
    var updateUrlWithPage = function(pageNumber) {
        // 검색 중이면 URL 변경하지 않음
        if (isSearching()) {
            // 페이지 상태만 변경하고 URL은 변경하지 않음
            setPage(pageNumber);
            setSearchParams(function(prev) {
                return ProductsList_objectSpread({}, prev, {
                    page: pageNumber
                });
            });
            return;
        }
        var path = router.asPath.split("?")[0];
        var pathSegments = path.split("/").filter(function(segment) {
            return segment !== "";
        });
        if (pathSegments[0] === "products") {
            var newPath = "/products/";
            // 전체 상품 목록 페이지 (/products/ 또는 /products/2/)
            if (pathSegments.length === 1 || pathSegments.length === 2 && (0,NumberCheck/* numberCheck */.M)(pathSegments[1])) {
                if (pageNumber === 1) {
                    newPath = "/products/";
                } else {
                    newPath = "/products/".concat(pageNumber, "/");
                }
            } else if (pathSegments.length >= 2) {
                var category = pathSegments[1];
                // 카테고리+해시태그 형태인 경우
                if (pathSegments.length >= 3 && pathSegments[2] && !(0,NumberCheck/* numberCheck */.M)(pathSegments[2])) {
                    var hash = pathSegments[2];
                    if (pageNumber === 1) {
                        newPath = "/products/".concat(category, "/").concat(hash, "/");
                    } else {
                        newPath = "/products/".concat(category, "/").concat(hash, "/").concat(pageNumber, "/");
                    }
                } else {
                    if (pageNumber === 1) {
                        newPath = "/products/".concat(category, "/");
                    } else {
                        newPath = "/products/".concat(category, "/").concat(pageNumber, "/");
                    }
                }
            }
            var normalizePath = function(p) {
                return p.replace(/\/+$/, "") + "/";
            };
            var normalizedNew = normalizePath(newPath);
            var normalizedCurrent = normalizePath(path);
            if (normalizedNew !== normalizedCurrent) {
                // 페이지 상태 업데이트
                setPage(pageNumber);
                setSearchParams(function(prev) {
                    return ProductsList_objectSpread({}, prev, {
                        page: pageNumber
                    });
                });
                // 실제 URL 변경 실행 - 페이지가 1이면 replace 사용
                if (pageNumber === 1) {
                    router.replace(newPath, undefined, {
                        shallow: true
                    });
                } else {
                    router.push(newPath, undefined, {
                        shallow: true
                    });
                }
            } else {
                console.log("URL \uB3D9\uC77C");
            }
        }
    };
    // 카테고리나 해시태그 변경 시 페이지 리셋 및 카테고리 정보 설정
    (0,react.useEffect)(function() {
        if (!router.isReady || !(dummyList === null || dummyList === void 0 ? void 0 : dummyList.category)) return;
        // URL에서 slug와 hash 확인
        var _query = router.query, slug = _query.slug, hash = _query.hash;
        var categoryCode = null;
        var hashTag = hash || "";
        var pageNumber = initialPage;
        // 마지막 경로 세그먼트가 숫자인지 확인 (페이지 번호)
        var pathSegments = router.asPath.split("/").filter(function(segment) {
            return segment !== "";
        });
        var lastSegment = pathSegments[pathSegments.length - 1];
        var isLastSegmentNumber = lastSegment && !isNaN(parseInt(lastSegment, 10));
        if (isLastSegmentNumber) {
            pageNumber = parseInt(lastSegment, 10);
        }
        // hash가 숫자인지 확인
        if (hash && (0,NumberCheck/* numberCheck */.M)(hash)) {
            // hash가 숫자인 경우, 페이지 번호로 처리
            hashTag = ""; // 해시태그는 없음
        }
        // 카테고리 코드 결정
        if (disableRouting && fixedCategory) {
            categoryCode = fixedCategory;
        } else if (router.query.code) {
            categoryCode = router.query.code;
        } else if (isNumericSlug) {
            // 숫자 슬러그인 경우 카테고리 설정 건너뜀
            return;
        } else if (slug && (dummyList === null || dummyList === void 0 ? void 0 : dummyList.category)) {
            var matchedCategory = dummyList.category.find(function(cat) {
                return cat.ename === slug;
            });
            if (matchedCategory) {
                categoryCode = matchedCategory.code;
            }
        }
        if (categoryCode) {
            // 카테고리 정보 설정
            var foundCategory = dummyList.category.find(function(cat) {
                return cat.code === categoryCode;
            });
            if (foundCategory) {
                // 카테고리 정보 설정
                setCategoryName(foundCategory.name || "");
                setCategorySizeSearch(foundCategory.search || "");
                // 해시태그 목록 설정
                var tempTags = foundCategory.hashTag || [];
                var safeHashTags = Array.isArray(tempTags) ? tempTags : [];
                setCategoryHash(safeHashTags);
                // 이전 카테고리/해시태그와 비교하여 변경됐는지 확인
                var prevCategory = currentCategory.code;
                var prevHash = currentCategory.hash;
                // 카테고리나 해시태그가 변경된 경우에만 데이터 초기화
                if (prevCategory !== categoryCode || prevHash !== hashTag) {
                    // 페이지 번호 유지 - 검색 조건 변경 시에도 현재 페이지 유지
                    if (isLastSegmentNumber) {
                        // 페이지 번호가 URL에 있으면 그 번호로 설정
                        setPage(pageNumber);
                        setSearchParams(function(prev) {
                            return ProductsList_objectSpread({}, prev, {
                                page: pageNumber
                            });
                        });
                    } else if (!hash || !(0,NumberCheck/* numberCheck */.M)(hash)) {
                        // 페이지 번호가 없고 해시태그도 숫자가 아닌 경우에만 페이지 초기화
                        resetPage(1);
                        setPage(1);
                        setSearchParams(function(prev) {
                            return ProductsList_objectSpread({}, prev, {
                                page: 1
                            });
                        });
                    }
                    // 캐시된 상품 데이터 무효화 (새로운 요청 보장)
                    queryClient.invalidateQueries([
                        "categoryProducts"
                    ]);
                }
                // 현재 카테고리 정보 설정 - 페이지 번호와 관계없이 항상 업데이트
                setCurrentCategory({
                    code: categoryCode,
                    hash: hashTag
                });
                // Redux 상태 업데이트
                _$updateProductCategory(dummyList.category);
                _$updateProductFilters({
                    hash: hashTag
                });
            }
        } else if (dummyList === null || dummyList === void 0 ? void 0 : dummyList.category) {
        // 기존 리다이렉트 로직
        // if (!disableRouting && !isNumericSlug && !router.query.subTitle) {
        //   router.replace("/products/No-Tape-Box/", undefined, { shallow: true });
        // }
        }
    }, [
        router.asPath,
        router.query,
        dummyList,
        router.isReady,
        disableRouting,
        fixedCategory,
        isNumericSlug, 
    ]);
    // 페이지 변경 처리 함수
    var handlePageChange = function(newPage) {
        // 유효한 페이지 번호인지 확인
        var maxPages = isNumericSlug ? modifiedPaginationProps.pages : regularPaginationProps.pages;
        if (newPage === currentPage) {
            return;
        }
        if (newPage <= 0 || newPage > maxPages) {
            return;
        }
        window.scrollTo(0, 520);
        // 검색 중일 때는 URL 변경 없이 페이지 상태만 업데이트
        if (isSearching()) {
            setPage(newPage);
            setSearchParams(function(prev) {
                return ProductsList_objectSpread({}, prev, {
                    page: newPage
                });
            });
        } else {
            // 검색 중이 아닐 때만 URL 업데이트
            updateUrlWithPage(newPage);
        }
        // 데이터 요청
        if (isNumericSlug) {
            queryClient.invalidateQueries({
                queryKey: [
                    "products",
                    newPage
                ],
                refetchActive: true
            });
        } else {
            queryClient.invalidateQueries({
                queryKey: [
                    "categoryProducts",
                    currentCategory.code,
                    currentCategory.hash,
                    newPage, 
                ],
                refetchActive: true
            });
        }
    };
    // URL에서 페이지 정보를 추출하여 동기화 (검색 중이면 URL 유지)
    var syncPageFromUrl = function() {
        if (!router.isReady) return;
        // 검색 중이면 URL에서 페이지 동기화하지 않음
        if (isSearching()) {
            return;
        }
        // URL 경로 분석
        var path = router.asPath.split("?")[0];
        var pathSegments = path.split("/").filter(function(segment) {
            return segment !== "";
        });
        // 페이지 번호 확인
        var pageFromUrl = 1; // 기본값
        if (isNumericSlug && pathSegments.length > 1) {
            // /products/2/ 형태
            pageFromUrl = parseInt(pathSegments[1], 10);
        } else if (pathSegments.length >= 3) {
            // 카테고리 또는 해시태그 페이지의 마지막 세그먼트가 숫자인지 확인
            var lastSegment = pathSegments[pathSegments.length - 1];
            if (!isNaN(parseInt(lastSegment, 10))) {
                pageFromUrl = parseInt(lastSegment, 10);
            }
        }
        // 현재 상태와 URL의 페이지 번호가 다른 경우에만 업데이트
        if (pageFromUrl && pageFromUrl !== page) {
            setPage(pageFromUrl);
            setSearchParams(function(prev) {
                return ProductsList_objectSpread({}, prev, {
                    page: pageFromUrl
                });
            });
        }
    };
    // URL 변경 시 페이지 동기화 (검색 중이 아닐 때만)
    (0,react.useEffect)(function() {
        if (isSearching()) {
            return;
        }
        syncPageFromUrl();
    }, [
        router.asPath,
        router.isReady
    ]);
    // 페이지 변경 시 상품 목록 업데이트 - 일반 카테고리 뷰만 해당
    (0,react.useEffect)(function() {
        if (!isNumericSlug) {
            var ref;
            if ((categoryProductsData === null || categoryProductsData === void 0 ? void 0 : (ref = categoryProductsData.items) === null || ref === void 0 ? void 0 : ref.length) > 0) {
                var startIdx = (currentPage - 1) * limit;
                var endIdx = startIdx + limit;
                var pagedProducts = categoryProductsData.items.slice(startIdx, endIdx);
                setProductList(pagedProducts);
            } else if (filteredProducts.length > 0) {
                var startIdx1 = (currentPage - 1) * limit;
                var endIdx1 = startIdx1 + limit;
                var pagedProducts1 = filteredProducts.slice(startIdx1, endIdx1);
                setProductList(pagedProducts1);
            }
        }
    }, [
        currentPage,
        filteredProducts,
        categoryProductsData,
        limit,
        isNumericSlug, 
    ]);
    // 비회원 바로 구매 모달 오픈
    var handleLoginModal = function() {
        setOpenLoginModal(function(prev) {
            return !prev;
        });
    };
    var handleListViewType = function(type) {
        if (viewType === type) {
            return;
        }
        localStorage.setItem("P_viewType", type);
        setViewType(type);
    };
    // 초기 로드 및 뷰 타입 설정
    (0,react.useEffect)(function() {
        if (!router.isReady) return;
        if (userDevice === "mobile") {
            setViewType("grid");
            setViewType(localStorage.setItem("P_viewType", "grid"));
        } else if (localStorage.getItem("P_viewType")) {
            setViewType(localStorage.getItem("P_viewType"));
        } else if (router.query.code == "13" || router.query.code == "11") {
            setViewType("grid");
        } else {
            setViewType("list");
        }
    }, [
        router.isReady,
        userDevice
    ]);
    // 바로 구매하기
    var purchaseDirect = function(product) {
        return function() {
            sessionStorage.setItem("directOrder", JSON.stringify([
                ProductsList_objectSpread({}, product, {
                    cnt: 1
                })
            ]));
            if (!(0,auth/* getCookie */.ej)("token") && !openLoginModal) {
                handleLoginModal();
                return;
            } else {
                document.body.style.removeProperty("overflow");
                sessionStorage.setItem("directOrder", JSON.stringify([
                    ProductsList_objectSpread({}, product, {
                        cnt: 1
                    })
                ]));
                router.push({
                    pathname: "/checkout",
                    query: {
                        type: "direct"
                    }
                });
            }
        };
    };
    // 필터링 적용
    (0,react.useEffect)(function() {
        if (!isNumericSlug) {
            // 숫자 슬러그가 아닌 경우에만 필터링 적용
            var filtered = ProductsList_toConsumableArray(allProducts);
            setFilteredProducts(filtered);
        }
    }, [
        allProducts,
        productFilters,
        isNumericSlug
    ]);
    // 숫자 슬러그일 때 페이지 설정
    (0,react.useEffect)(function() {
        if (router.isReady && isNumericSlug) {
            var pageNumber = parseInt(router.query.slug, 10);
            if (pageNumber > 0 && pageNumber !== page) {
                // 상태 업데이트
                setPage(pageNumber);
                setSearchParams(function(prev) {
                    return ProductsList_objectSpread({}, prev, {
                        page: pageNumber
                    });
                });
            }
        }
    }, [
        router.isReady,
        router.query.slug,
        isNumericSlug
    ]);
    var modalScrollHook = (0,modalOverflowHook/* default */.Z)(openLoginModal);
    // 페이지네이션 버튼 기능에 필요한 NoticePagination 컴포넌트에 전달할 핸들러
    var customHandleActive = function(pageNumber) {
        // 페이지 변경 처리 - 검색 조건 유지하면서 페이지 이동
        if (pageNumber !== page) {
            // 현재 페이지와 다른 경우에만 처리
            try {
                // 스크롤 이동
                window.scrollTo(0, 520);
                // 검색 중일 때는 URL 변경 없이 페이지 상태만 업데이트
                if (isSearching()) {
                    setPage(pageNumber);
                    setSearchParams(function(prev) {
                        return ProductsList_objectSpread({}, prev, {
                            page: pageNumber
                        });
                    });
                } else {
                    // 검색 중이 아닐 때만 URL 업데이트
                    var path = router.asPath.split("?")[0];
                    var pathSegments = path.split("/").filter(function(segment) {
                        return segment !== "";
                    });
                    var newPath = "";
                    if (isNumericSlug) {
                        // 전체 상품 목록 페이지 형태
                        newPath = pageNumber === 1 ? "/products/" : "/products/".concat(pageNumber, "/");
                    } else if (pathSegments.length >= 2) {
                        // 현재 URL 분석
                        var category = pathSegments[1];
                        // 카테고리+해시태그 형태인 경우
                        if (pathSegments.length >= 3 && pathSegments[2] && !(0,NumberCheck/* numberCheck */.M)(pathSegments[2])) {
                            var hash = pathSegments[2];
                            newPath = pageNumber === 1 ? "/products/".concat(category, "/").concat(hash, "/") : "/products/".concat(category, "/").concat(hash, "/").concat(pageNumber, "/");
                        } else {
                            // 카테고리만 있는 경우
                            newPath = pageNumber === 1 ? "/products/".concat(category, "/") : "/products/".concat(category, "/").concat(pageNumber, "/");
                        }
                    }
                    // 페이지 상태 업데이트
                    setPage(pageNumber);
                    setSearchParams(function(prev) {
                        return ProductsList_objectSpread({}, prev, {
                            page: pageNumber
                        });
                    });
                    // URL 변경
                    if (pageNumber === 1) {
                        router.replace(newPath, undefined, {
                            shallow: true
                        });
                    } else {
                        router.push(newPath, undefined, {
                            shallow: true
                        });
                    }
                }
                // 데이터 요청
                if (isNumericSlug) {
                    queryClient.invalidateQueries({
                        queryKey: [
                            "products",
                            pageNumber
                        ],
                        refetchActive: true
                    });
                } else {
                    queryClient.invalidateQueries({
                        queryKey: [
                            "categoryProducts",
                            currentCategory.code,
                            currentCategory.hash,
                            pageNumber, 
                        ],
                        refetchActive: true
                    });
                }
            } catch (error) {
                console.error("\uD398\uC774\uC9C0 \uC774\uB3D9 \uC911 \uC624\uB958:", error);
            }
        }
    };
    //배너 데이터
    var ref22 = useCategoryListQuery(), categoryData = ref22.data;
    //구버전
    // const matchedCategory = categoryData?.find(
    //   (cat) =>
    //     String(cat.code) === String(router.query.code || currentCategory.code)
    // );
    var matchedCategory1 = categoryData === null || categoryData === void 0 ? void 0 : categoryData.find(function(cat) {
        return String(cat.ename) === String(router.query.slug || currentCategory.code);
    });
    //브랜드 필터 핸들러
    var handleBrandCheckBox = function(e) {
        var _target = e.target, value = _target.value, checked = _target.checked;
        setSearchParams(function(prev) {
            var prevBrands = prev.brands || [];
            var updatedBrands = checked ? Array.from(new Set(ProductsList_toConsumableArray(prevBrands).concat([
                value
            ]))) : prevBrands.filter(function(brandCode) {
                return brandCode !== value;
            });
            return ProductsList_objectSpread({}, prev, {
                page: 1,
                brands: updatedBrands
            });
        });
        // 페이지 상태도 1로 초기화
        setPage(1);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Suspense, {
        children: [
            isNumericSlug ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
                    pageTitle: seoData === null || seoData === void 0 ? void 0 : seoData.name,
                    pageDesc: seoData === null || seoData === void 0 ? void 0 : seoData.description,
                    pageImg: seoData === null || seoData === void 0 ? void 0 : seoData.image,
                    pageKeyword: seoData === null || seoData === void 0 ? void 0 : seoData.keywords,
                    noBreadcrumb: "d-none",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                            className: "container mt-15 position-relative",
                            children: (dummyList === null || dummyList === void 0 ? void 0 : dummyList.category) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Category/* default */.Z, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "container mt-40",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Proucts_list_styles/* ProductsGrid */.n2, {
                                    children: productsData === null || productsData === void 0 ? void 0 : (ref25 = productsData.data) === null || ref25 === void 0 ? void 0 : ref25.map(function(item, i) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SingleProduct/* default */.Z, {
                                                product: item
                                            })
                                        }, i);
                                    })
                                }),
                                (productsData === null || productsData === void 0 ? void 0 : (ref1 = productsData.data) === null || ref1 === void 0 ? void 0 : ref1.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "d-flex w-100 justify-content-center mt-30 mb-30",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(notice_pagination/* default */.Z, {
                                            prev: function() {
                                                return handlePageChange(page - 1);
                                            },
                                            currentPage: page,
                                            getPaginationGroup: getPaginationGroup(),
                                            next: function() {
                                                return handlePageChange(page + 1);
                                            },
                                            pages: pages,
                                            nextEnd: function() {
                                                return handlePageChange(pages);
                                            },
                                            prevStart: function() {
                                                return handlePageChange(1);
                                            },
                                            handleActive: customHandleActive
                                        }),
                                        pagination.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                            className: "d-none d-md-flex align-items-center ml-10",
                                            children: [
                                                page,
                                                " / ",
                                                pages
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }) : // 일반 카테고리 페이지인 경우 기존 레이아웃
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* default */.Z, {
                noBreadcrumb: "d-none",
                parent: "\uD648",
                sub: "\uC0C1\uD488\uAD6C\uB9E4",
                subTitle: seoData === null || seoData === void 0 ? void 0 : seoData.name,
                subChild: router.query.hash && (0,NumberCheck/* numberCheck */.M)(router.query.hash) ? "" : router.query.hash,
                pageTitle: router.query.hash && !(0,NumberCheck/* numberCheck */.M)(router.query.hash) ? "".concat(seoData === null || seoData === void 0 ? void 0 : seoData.name, ", ").concat(router.query.hash) : seoData === null || seoData === void 0 ? void 0 : seoData.name,
                pageDesc: seoData === null || seoData === void 0 ? void 0 : seoData.description,
                pageImg: seoData === null || seoData === void 0 ? void 0 : seoData.image,
                pageKeyword: seoData === null || seoData === void 0 ? void 0 : seoData.keywords,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Proucts_list_styles/* Container */.W2, {
                    className: "mt-50 mb-50",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "container mb-30",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "m_title",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumb2/* default */.Z, {
                                    categoryName: categoryName,
                                    categoryHash: categoryHash,
                                    hash: router.query.hash
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "row",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Proucts_list_styles/* StickyMenu */.af, {
                                        className: "col-lg-1-5 primary-sidebar sticky-sidebar",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "sidebar-widget widget-category-2 mb-30",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                        className: "section-title style-1 mb-30",
                                                        children: "\uC0C1\uC138 \uBD84\uB958"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Filter_Tags, {
                                                        categoryHash: categoryHash,
                                                        categoryName: categoryName
                                                    })
                                                ]
                                            }),
                                            (matchedCategory1 === null || matchedCategory1 === void 0 ? void 0 : (ref2 = matchedCategory1.brands) === null || ref2 === void 0 ? void 0 : ref2.length) >= 2 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "sidebar-widget widget-category-2 mb-30",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                        className: "section-title style-1 mb-30",
                                                        children: "\uBE0C\uB79C\uB4DC"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox, {
                                                        filters: (matchedCategory1 === null || matchedCategory1 === void 0 ? void 0 : matchedCategory1.brands.map(function(brand) {
                                                            return {
                                                                name: "brand",
                                                                value: brand.code,
                                                                label: brand.name,
                                                                checked: searchParams.brands.includes(brand.code)
                                                            };
                                                        })) || [],
                                                        handleCheckBox: handleBrandCheckBox
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Proucts_list_styles/* MenuBanner */.qx, {
                                                className: "banner-img fadeIn mb-lg-0 animated",
                                                children: prodLeftBtm && prodLeftBtm.length > 0 && prodLeftBtm.slice(0, 4).map(function(el, i) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: el.link_url,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            target: el.new_win === "Y" ? "_blank" : "_self",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                src: el.P_FileUrl,
                                                                alt: el.img_alt
                                                            })
                                                        })
                                                    }, i);
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "col-lg-4-5 mb-30",
                                        children: [
                                            (matchedCategory1 === null || matchedCategory1 === void 0 ? void 0 : matchedCategory1.banner) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                onClick: function() {
                                                    if (matchedCategory1.banner_link) {
                                                        router.push(matchedCategory1.banner_link);
                                                    }
                                                },
                                                style: {
                                                    cursor: matchedCategory1.banner_link ? "pointer" : "default"
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: matchedCategory1.banner,
                                                    alt: matchedCategory1.name
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "p_title",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "breadcrumb",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumb2/* default */.Z, {
                                                            categoryName: categoryName,
                                                            categoryHash: categoryHash,
                                                            hash: router.query.hash,
                                                            ename: ename
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Proucts_list_styles/* ListViewTypeWrapper */.zw, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Proucts_list_styles/* ListViewSelectBox */.Zs, {
                                                            listViewType: viewType ? viewType : "grid",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: !viewType || viewType === "grid" ? "selected" : "",
                                                                    onClick: function() {
                                                                        return handleListViewType("grid");
                                                                    },
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                        className: "fi-rs-grid"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: viewType && viewType === "list" ? "selected" : "",
                                                                    onClick: function() {
                                                                        return handleListViewType("list");
                                                                    },
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                        className: "fi-rs-list"
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Proucts_list_styles/* FilterWrapper */.kI, {
                                                className: "",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        className: "cnt",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                                className: "text-brand",
                                                                children: (categoryProductsData === null || categoryProductsData === void 0 ? void 0 : categoryProductsData.total_count) || 0
                                                            }),
                                                            "\uAC1C\uC758 \uC0C1\uD488"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "filter",
                                                        children: categorySizeSearch !== "N" && /*#__PURE__*/ (0,jsx_runtime.jsx)(list_ProductSizeFilter, {
                                                            categorySizeSearch: categorySizeSearch,
                                                            allProducts: allProducts,
                                                            setAllProducts: setAllProducts,
                                                            setFilteredProducts: setFilteredProducts,
                                                            selectedCategory: ((ref3 = router.query) === null || ref3 === void 0 ? void 0 : ref3.code) || currentCategory.code,
                                                            createPagination: createPagination,
                                                            searchParams: searchParams,
                                                            setSearchParams: setSearchParams,
                                                            setPage: setPage,
                                                            currentCategory: currentCategory,
                                                            resetPagination: resetPage
                                                        })
                                                    })
                                                ]
                                            }),
                                            (!viewType || viewType === "grid") && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Proucts_list_styles/* ProductsGrid */.n2, {
                                                children: [
                                                    (categoryProductsData === null || categoryProductsData === void 0 ? void 0 : (ref4 = categoryProductsData.items) === null || ref4 === void 0 ? void 0 : ref4.length) === 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Proucts_list_styles/* ProductsSignWrapper */.m9, {
                                                        style: {
                                                            gridColumn: "span 4"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                                children: "\uCC3E\uC73C\uC2DC\uB294 \uC0C1\uD488\uC774 \uC5C6\uB2E4\uBA74 \uC6B0\uCE21 \uD558\uB2E8\uC758 \uCC44\uB110\uD1A1\uC73C\uB85C \uBB38\uC758\uB97C \uB123\uC5B4\uC8FC\uC2DC\uAC70\uB098"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                                children: "\uB9DE\uCDA4\uC81C\uC791 \uC11C\uBE44\uC2A4\uB97C \uC774\uC6A9\uD574\uBCF4\uC138\uC694."
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                className: "btn",
                                                                href: "/customizing/customizing-products/",
                                                                children: "\uB9DE\uCDA4\uC81C\uC791 \uBC14\uB85C\uAC00\uAE30"
                                                            })
                                                        ]
                                                    }),
                                                    categoryProductsData === null || categoryProductsData === void 0 ? void 0 : (ref5 = categoryProductsData.items) === null || ref5 === void 0 ? void 0 : ref5.map(function(item, i) {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SingleProduct/* default */.Z, {
                                                                product: item,
                                                                dummyList: dummyList,
                                                                listViewType: viewType ? viewType : "grid"
                                                            })
                                                        }, i);
                                                    })
                                                ]
                                            }),
                                            viewType && viewType === "list" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Proucts_list_styles/* ProductsList */.RX, {
                                                children: [
                                                    (categoryProductsData === null || categoryProductsData === void 0 ? void 0 : (ref6 = categoryProductsData.items) === null || ref6 === void 0 ? void 0 : ref6.length) === 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Proucts_list_styles/* ProductsSignWrapper */.m9, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                                children: "\uCC3E\uC73C\uC2DC\uB294 \uC0C1\uD488\uC774 \uC5C6\uB2E4\uBA74 \uC6B0\uCE21 \uD558\uB2E8\uC758 \uCC44\uB110\uD1A1\uC73C\uB85C \uBB38\uC758\uB97C \uB123\uC5B4\uC8FC\uC2DC\uAC70\uB098"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                                children: "\uB9DE\uCDA4\uC81C\uC791 \uC11C\uBE44\uC2A4\uB97C \uC774\uC6A9\uD574\uBCF4\uC138\uC694."
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                className: "btn",
                                                                href: "/customizing/customizing-products/",
                                                                children: "\uB9DE\uCDA4\uC81C\uC791 \uBC14\uB85C\uAC00\uAE30"
                                                            })
                                                        ]
                                                    }),
                                                    categoryProductsData && (categoryProductsData === null || categoryProductsData === void 0 ? void 0 : (ref7 = categoryProductsData.items) === null || ref7 === void 0 ? void 0 : ref7.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(TableTypeList/* default */.Z, {
                                                        productList: categoryProductsData.items,
                                                        dummyList: dummyList,
                                                        purchaseDirect: purchaseDirect
                                                    })
                                                ]
                                            }),
                                            categoryProductsData && (categoryProductsData === null || categoryProductsData === void 0 ? void 0 : categoryProductsData.items.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "d-flex w-100 justify-content-center mt-30",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(notice_pagination/* default */.Z, {
                                                        prev: function() {
                                                            return handlePageChange(page - 1);
                                                        },
                                                        currentPage: page,
                                                        getPaginationGroup: getPaginationGroup(),
                                                        next: function() {
                                                            return handlePageChange(page + 1);
                                                        },
                                                        pages: pages,
                                                        nextEnd: function() {
                                                            return handlePageChange(pages);
                                                        },
                                                        prevStart: function() {
                                                            return handlePageChange(1);
                                                        },
                                                        handleActive: customHandleActive
                                                    }),
                                                    pagination.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                        className: "d-none d-md-flex align-items-center ml-10",
                                                        children: [
                                                            currentPage,
                                                            " / ",
                                                            pages
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            openLoginModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(requestLoginModal/* default */.Z, {
                handleLoginModal: handleLoginModal,
                openLoginModal: openLoginModal,
                purchaseDirect: purchaseDirect,
                product: JSON.parse(sessionStorage.getItem("directOrder"))[0],
                cnt: 1
            })
        ]
    });
};
var ProductsList_mapStateToProps = function(state) {
    return {
        products: state.products,
        productFilters: state.productFilters,
        banners: state.banners,
        dummyList: state.dummyList,
        loading: state.loading.loading
    };
};
var ProductsList_mapDidpatchToProps = {
    fetchProduct: fetchProduct,
    updateProductFilters: productFiltersAction/* updateProductFilters */.lG,
    updateProductCategory: productFiltersAction/* updateProductCategory */.pP,
    isLoading: loading/* isLoading */.h,
    isLoaded: loading/* isLoaded */.k
};
/* harmony default export */ var list_ProductsList = ((0,es/* connect */.$j)(ProductsList_mapStateToProps, ProductsList_mapDidpatchToProps)(ProductsList));


/***/ })

}]);